import { SceneWrapper } from '~/components';
import { FormikProps, isEmpty, useFormikContext } from '~/modules';
import { CreditSimulationPixKeyFormValues } from './schema';
import { ButtonComponent, Input } from './styles';

const CreditSimulationPixKey = () => {
  const {
    values,
    errors,
    setFieldValue,
    submitForm,
    isValid,
  }: FormikProps<CreditSimulationPixKeyFormValues> = useFormikContext();

  return (
    <SceneWrapper
      footer={
        <ButtonComponent
          id="btn-simulation-value"
          onPress={submitForm}
          disabled={!isValid || isEmpty(values.CreditSimulationPixKey)}
          fullWidth
        >
          AVANÇAR
        </ButtonComponent>
      }
    >
      <Input
        name="CreditSimulationPixKey"
        id="CreditSimulationPixKey"
        value={values.CreditSimulationPixKey}
        onChange={(e) =>
          setFieldValue('CreditSimulationPixKey', e.target.value)
        }
        label="Chave PIX"
        errors={errors?.CreditSimulationPixKey}
      />
    </SceneWrapper>
  );
};

export default CreditSimulationPixKey;
